export enum SitesQueryKeys {
  GetAll = 'sites/getAll',
  GetContentById = 'sites/getContentById',
  Dossier = 'sites/dossier',
  Create = 'sites/create',
  Edit = 'sites/edit',
  Delete = 'sites/delete',
  Autocomplete = 'sites/autocomplete',
  Breadcrumb = 'sites/breadcrumb',
  CheckSiteHaveSearchConsoleAccount = 'sites/checkSiteHaveSearchConsoleAccount',
  ChangeVisibilityOfContentLastChangeDate = 'sites/changeVisibilityOfContentLastChangeDate',
}

export enum SiteArchivesKeys {
  GetArchives = 'site-archives/getArchives',
  UploadArchive = 'site-archives/uploadArchive',
  ExportArchive = 'site-archives/exportArchive',
}
